"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AppRoute = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _reactRedux = require("react-redux");

var _reactRouterRedux = require("react-router-redux");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 * Map state to props
 *
 * @param {Object} state
 */


var mapStateToProps = function mapStateToProps(state) {
  return {
    token: state.auth.token
  };
};
/**
 * Map dispatch to props
 *
 * @param {function} dispatch
 */


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    redirect: function redirect(token) {
      return dispatch((0, _reactRouterRedux.push)(token));
    }
  };
};

var AppRoute = /*#__PURE__*/function (_React$Component) {
  _inherits(AppRoute, _React$Component);

  function AppRoute(props) {
    var _this;

    _classCallCheck(this, AppRoute);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AppRoute).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "state", {
      component: null
    });

    return _this;
  }

  _createClass(AppRoute, [{
    key: "componentDidMount",
    value: function componentDidMount(props) {// console.error('mounted');
      // if(this.props.load && !this.state.component) {
      //   this.props.load()
      //     .then(component => {
      //       this.setState({
      //         component: component.default ? component.default : component
      //       })
      //     })
      // }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this; // Prevent authenticated to access public routes


      if (this.props.unAuthenticatedOnly && this.props.token) {
        return _react["default"].createElement(_reactRouterDom.Redirect, {
          to: "/"
        });
      } // Prevent nonauthenticated to access private routes


      if (this.props.authenticatedOnly && !this.props.token) {
        return _react["default"].createElement(_reactRouterDom.Redirect, {
          to: "/login"
        });
      }

      var _this$props = this.props,
          Component = _this$props.component,
          Layout = _this$props.layout,
          rest = _objectWithoutProperties(_this$props, ["component", "layout"]);

      if (this.props.load) {
        Component = function Component() {
          return _react["default"].createElement(DynamicLoad, {
            load: _this2.props.load
          });
        };
      }

      if (Layout) {
        return _react["default"].createElement(_reactRouterDom.Route, _extends({}, rest, {
          render: function render(props) {
            return _react["default"].createElement(Layout, null, _react["default"].createElement(Component, props));
          }
        }));
      } else {
        return _react["default"].createElement(_reactRouterDom.Route, _extends({}, rest, {
          render: function render(props) {
            return _react["default"].createElement(Component, props);
          }
        }));
      }
    }
  }]);

  return AppRoute;
}(_react["default"].Component);

exports.AppRoute = AppRoute;

var DynamicLoad = /*#__PURE__*/function (_React$Component2) {
  _inherits(DynamicLoad, _React$Component2);

  function DynamicLoad() {
    var _getPrototypeOf2;

    var _this3;

    _classCallCheck(this, DynamicLoad);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this3 = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DynamicLoad)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this3), "state", {
      component: null
    });

    return _this3;
  }

  _createClass(DynamicLoad, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this4 = this;

      if (this.props.load && !this.state.component) {
        this.props.load().then(function (component) {
          _this4.setState({
            component: component["default"] ? component["default"] : component
          });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.component) {
        var Component = this.state.component;
        return _react["default"].createElement(Component, null);
      }

      return _react["default"].createElement("div", null, "Loading");
    }
  }]);

  return DynamicLoad;
}(_react["default"].Component);

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AppRoute);

exports["default"] = _default;